export var CardSizes = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
};
